/*
 * Length: default in inches
 */
// matches 4.4 " or 4.4 inches or 4.4 in
var inchesRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\"|in|inch|inches)(\s{0,})$/);
var inchesSplit = new RegExp( /(\"|in|inch|inches)/ );
// matches 1/4 " or 1/4 inches or 1/4 in
var inchFracRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/);
// matches -42 or 42
var integerRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})$/);
// matches -42.0 or 42
var decimalRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})$/);

function parseInch(s) {
  var tokens = s.split(inchesSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Inches: " + s);
  }
  return Number(tokens[0]);
}

function parseInchFraction(s) {
  var tokens = s.split(inchesSplit);
  if (tokens.length > 0) {
    tokens = tokens[0].split(/\//);
    if (tokens.length > 1) {
      var numerator = tokens[0];
      var denomenator = parseInch(tokens[1]);
      if (!isNaN(numerator) && !isNaN(denomenator)) {
        return Number(numerator) / Number(denomenator);
      }
    }
  }
  throw ("Error Parsing Inch Fraction: " + s);
}

export function parseLength(s) {

  // replace smart quotes
  s = s.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');

  // no units, assume inches
  if (s.match(integerRegEx) || s.match(decimalRegEx)) { return Number(s); }

  if (s.match(inchesRegEx)) { return parseInch(s); }

  if (s.match(inchFracRegEx)) { return parseInchFraction(s); }

  return NaN
}

/*
 * Force: default in kips
 */
// matches 42 [lb,lbs,pound,pounds], 42.0 [lb,lbs,pound,pounds]
var lbsRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(lb|lbs|pound|pounds)(\s{0,})$/)
var lbsSplit = new RegExp(/(lb|lbs|pound|pounds)/)
// matches 42 k, 42.0 k or 42 kips or 42.0 kips
var kipsRegEx = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(k|kip|kips)(\s{0,})$/)
var kipsSplit = new RegExp(/(k|kip|kips)/)

function parseLbs(s) {
  var tokens = s.split(lbsSplit)
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Lbs: " + s)
  }
  return Number(tokens[0]) / 1000
}

function parseKips(s) {
  var tokens = s.split(kipsSplit);
  if (tokens.length <= 0 || isNaN(tokens[0])) {
    throw ("Error Parsing Kips: " + s);
  }
  return Number(tokens[0])
}

export function parseForce(s) {
  // no units, assume kips
  if (s.match(integerRegEx) || s.match(decimalRegEx)) { return Number(s); }

  if (s.match(lbsRegEx)) { return parseLbs(s); }
  
  if (s.match(kipsRegEx)) { return parseKips(s); }
  
  return NaN;
}

/*
 * Forces per unit area: default ksi
 */
var lbsPerInInRegEx = new RegExp( /^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(lb|lbs|pound|pounds)(\s{0,1})\/(\s{0,1})(in\^2|inch\^2)(\s{0,})$/ );
var lbsPerInInSplit = new RegExp( /(lb|lbs|pound|pounds)(\s{0,1})\/(\s{0,1})(in\^2|inch^2)/ );
var lbsPerFtFtRegEx = new RegExp( /^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(lb|lbs|pound|pounds)(\s{0,1})\/(\s{0,1})(ft\^2|foot\^2)(\s{0,})$/ );
var lbsPerFtFtSplit = new RegExp( /(lb|lbs|pound|pounds)(\s{0,1})\/(\s{0,1})(ft\^2|foot^2)/ );
var kipPerInInRegEx = new RegExp( /^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(k|kip|kips)(\s{0,1})\/(\s{0,1})(in\^2|inch^2)(\s{0,})$/ );
var kipPerInInSplit = new RegExp( /(k|kip|kips)(\s{0,1})\/(\s{0,1})(in^2|inch\^2)/ );
var ksiRegEx = new RegExp( /^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(ksi)$/ );
var ksiSplit = new RegExp( /(ksi)/ );

function parseLbsPerInIn(s) {
    var tokens = s.split( lbsPerInInSplit )
    if( tokens.length <= 0 || isNaN(tokens[0])){
        throw("Error Parsing lb/in^2: " + s )
    }
    return Number(tokens[0]) / 1000
}

function parseLbsPerFtFt(s) {
  var tokens = s.split( lbsPerFtFtSplit )
  if( tokens.length <= 0 || isNaN(tokens[0])){
      throw("Error Parsing lb/ft^2: " + s )
  }
  return Number(tokens[0]) / 1000 * 144
}

function parseKipPerInIn(s) {
    var tokens = s.split(kipPerInInSplit)
    if( tokens.length <= 0 || isNaN(tokens[0])){
        throw("Error Parsing kip/in^2: " + s )
    }
    return Number(tokens[0])
}

function parseKsi(s) {
    var tokens = s.split(ksiSplit)
    if( tokens.length <= 0 || isNaN(tokens[0])){
        throw("Error Parsing ksi: " + s )
    }
    return Number(tokens[0])
}

export function parsePressure( s ) {
  // no units assume ksi
  if(s.match( integerRegEx ) || s.match( decimalRegEx )) { return Number(s) }
      
  if( s.match( lbsPerInInRegEx ) ) { return parseLbsPerInIn(s) }

  if( s.match( lbsPerFtFtRegEx ) ) { return parseLbsPerFtFt(s) }
  
  if( s.match( kipPerInInRegEx )) { return parseKipPerInIn(s) }
  
  if( s.match( ksiRegEx ) ) { return parseKsi(s) }

  return NaN;
}